import { useState, useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useProductFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Initialize filters from URL
  const [filters, setFilters] = useState({
    search: searchParams.get('search') || '',
    category: searchParams.get('category') || '',
    status: searchParams.get('status') || '',
    minPrice: searchParams.get('min_price') || '',
    maxPrice: searchParams.get('max_price') || '',
    lowStock: searchParams.get('low_stock') === 'true',
    sortBy: searchParams.get('sort') || 'created_at',
    sortOrder: searchParams.get('order') || 'desc'
  });

  const updateFilters = useCallback((newFilters) => {
    setFilters(newFilters);
    
    // Update URL
    const params = new URLSearchParams();
    Object.entries(newFilters).forEach(([key, value]) => {
      if (value && value !== '') {
        if (key === 'lowStock') {
          if (value) params.append('low_stock', 'true');
        } else if (key === 'sortBy') {
          params.append('sort', value);
        } else if (key === 'sortOrder') {
          params.append('order', value);
        } else {
          params.append(key.replace(/([A-Z])/g, '_$1').toLowerCase(), value);
        }
      }
    });
    
    setSearchParams(params);
  }, [setSearchParams]);

  const clearFilters = useCallback(() => {
    const defaultFilters = {
      search: '',
      category: '',
      status: '',
      minPrice: '',
      maxPrice: '',
      lowStock: false,
      sortBy: 'created_at',
      sortOrder: 'desc'
    };
    updateFilters(defaultFilters);
  }, [updateFilters]);

  const activeFiltersCount = useMemo(() => {
    let count = 0;
    if (filters.search) count++;
    if (filters.category) count++;
    if (filters.status) count++;
    if (filters.minPrice || filters.maxPrice) count++;
    if (filters.lowStock) count++;
    return count;
  }, [filters]);

  const hasActiveFilters = activeFiltersCount > 0;

  return {
    filters,
    updateFilters,
    clearFilters,
    activeFiltersCount,
    hasActiveFilters
  };
};

